let sideModal = class {
    constructor()
    {
        this.triggers = document.querySelectorAll("[data-side-modal]");
        this.cover = document.getElementById('side_modal_cover');
        this.modal = document.getElementById('side_modal');
        this.header = document.getElementById('sm_header');
        this.closeButton = this.header.querySelector('.dismiss');
        this.titleEl = this.header.querySelector('h5');
        this.loader = this.modal.querySelector('.loader');
        this.contentArea = this.modal.querySelector('.content');
        this.isOpen = false;
    }
    
    setUp() {
        // document.addEventListener('click', this.shouldOpenSideModal.bind(this));

        // this.triggers.forEach(trigger => {
        //     trigger.addEventListener("click", this.openSideModalAndLoadContent.bind(this));
        // });

        document.addEventListener("click", function(e){
            const target = e.target.closest("[data-side-modal]");
            if (target) {
                // console.log(target);
                e.preventDefault();
                window.smd.openSideModalAndLoadContent(target);
            }
        }, false);
        
        this.cover.addEventListener("click", this.closeSideModal.bind(this));
        this.closeButton.addEventListener("click", this.closeSideModal.bind(this));
        
        document.addEventListener("keydown", this.closeWithEscKey.bind(this));
    }

    closeWithEscKey(e)
    {
        if (e.keyCode === 27) {
            this.closeSideModal();
        }
    }

    // shouldOpenSideModal(e)
    // {
    //     if (e.target && e.target.dataset.sideModal) {
    //         this.openSideModal();
    //     }
    // }

    // openSideModal(e)
    // {
    //     this.isOpen = true;
    //     this.cover.classList.add('visible');
    //     this.modal.classList.remove('hidden');
    //     document.body.classList.add('ox-h');
    // }

    openSideModalAndLoadContent(e)
    {
        // e.preventDefault();
        this.isOpen = true;
        this.cover.classList.add('visible');
        this.modal.classList.remove('hidden');
        document.body.classList.add('ox-h');

        this.cleanAndSetLoading();
        this.setTitle(e.dataset.title);

        let url = e.href;
        let that = this;

        axios.get(url, {
        })
        .then(function (response) {
            that.setContent(response.data);

            // // Callback
            // const callback = e.dataset.callback;
            // if (typeof window.tmpFunc === 'function') { return; }
            // window.tmpFunc = new Function(callback);
            // window.tmpFunc();
            const eventLoaded = new Event("side-modal-loaded");
            document.dispatchEvent(eventLoaded);
        })
        .catch(function (error) {
            // console.log(error);
            new Toast('Cannot load content', Toast.TYPE_ERROR, Toast.TIME_NORMAL);

            that.setTitle('');
            that.setContent('');
            that.closeSideModal();
        });

    }

    closeSideModal()
    {
        if (this.isOpen) {
            const eventClosing = new Event("side-modal-closing");
            document.dispatchEvent(eventClosing);

            this.isOpen = false;
            this.cover.classList.remove('visible');
            this.modal.classList.add('hidden');
            document.body.classList.remove('ox-h');

            this.clean();

            const eventClosed = new Event("side-modal-closed");
            document.dispatchEvent(eventClosed);

            // Callback
            // window.tmpFunc = new Function();
            // window.tmpFunc();
        }
    }

    setTitle(title)
    {
        this.titleEl.innerHTML = title;
    }

    setContent(content)
    {
        this.loader.classList.remove('visible');
        this.contentArea.innerHTML = content;
    }

    clean()
    {
        this.contentArea.innerHTML = "";
    }

    cleanAndSetLoading()
    {
        this.clean();
        this.loader.classList.add('visible');
    }
};

let findSideModalTemplate = document.getElementById('side_modal');
if (findSideModalTemplate) {
    window.smd = new sideModal();
    window.smd.setUp();
}
